var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useRef } from 'react';
import { usePopper } from 'react-popper';
import styled, { css } from 'styled-components';
import { SAIcon, SAIcons, SAIconSize } from '../icon';
import { SAUX360Theme } from '../theme';
var Container = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    var theme = props.theme;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      display: flex;\n      flex-direction: row;\n      justify-content: left;\n      align-items: flex-start;\n      padding: 12px;\n      position: static;\n      max-width: 360px;\n      left: calc(50% - 360px / 2);\n      top: 0%;\n      bottom: 0%;\n      /* Backgrounds/Tooltip Blue */\n      background: ", ";\n      border-radius: 4px;\n      color: ", ";\n      font-size: {theme?.font.sizes.200};\n    "], ["\n      display: flex;\n      flex-direction: row;\n      justify-content: left;\n      align-items: flex-start;\n      padding: 12px;\n      position: static;\n      max-width: 360px;\n      left: calc(50% - 360px / 2);\n      top: 0%;\n      bottom: 0%;\n      /* Backgrounds/Tooltip Blue */\n      background: ", ";\n      border-radius: 4px;\n      color: ", ";\n      font-size: {theme?.font.sizes.200};\n    "])), props.variant === 'dark' ? theme === null || theme === void 0 ? void 0 : theme.colors.slate700 : theme === null || theme === void 0 ? void 0 : theme.colors.disabledGrey, props.variant === 'dark' ? 'white' : 'black');
});
var SATooltipBox = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  visibility: ", ";\n  z-index: ", ";\n"], ["\n  visibility: ", ";\n  z-index: ", ";\n"])), function (props) { return (props.visible ? 'show' : 'hidden'); }, function (props) { return props.zIndex; });
var IconWrapper = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding-right: 10px;\n"], ["\n  padding-right: 10px;\n"])));
var Title = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  font-weight: bold;\n"], ["\n  font-weight: bold;\n"])));
var ToolTipWrapper = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  cursor: pointer;\n  width: fit-content;\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 2px blue;\n  }\n"], ["\n  cursor: pointer;\n  width: fit-content;\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 2px blue;\n  }\n"])));
export function SATooltip(_a) {
    var title = _a.title, placement = _a.placement, content = _a.content, icon = _a.icon, variant = _a.variant, testId = _a.testId, wrapperTestId = _a.wrapperTestId, children = _a.children, zIndex = _a.zIndex;
    var _b = React.useState(false), toolTip = _b[0], setToolTip = _b[1];
    var wrapperRef = useRef();
    var tooltipRef = useRef();
    var _c = usePopper(wrapperRef.current, tooltipRef.current, {
        placement: placement,
        strategy: 'fixed',
    }), styles = _c.styles, attributes = _c.attributes;
    var mouseEventEnter = function () {
        setToolTip(true);
    };
    var mouseEventLeave = function () {
        setToolTip(false);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ToolTipWrapper, { "data-testid": wrapperTestId, onMouseEnter: mouseEventEnter, onMouseLeave: mouseEventLeave, onFocus: mouseEventEnter, onBlur: mouseEventLeave, ref: wrapperRef }, React.Children.only(children)),
        React.createElement(SATooltipBox, __assign({ ref: tooltipRef, style: styles.popper }, attributes.popper, { "data-testid": testId, visible: toolTip, zIndex: zIndex }),
            React.createElement(Container, { variant: variant },
                icon && variant === 'dark' && (React.createElement("div", null,
                    React.createElement(IconWrapper, null,
                        React.createElement(SAIcon, { icon: SAIcons[icon], size: SAIconSize.small, colorVariant: "light" })))),
                icon && variant === 'light' && (React.createElement("div", null,
                    React.createElement(IconWrapper, null,
                        React.createElement(SAIcon, { icon: SAIcons[icon], size: SAIconSize.small, colorVariant: "dark" })))),
                React.createElement("div", null,
                    title && React.createElement(Title, null, title),
                    React.createElement("p", null, content))))));
}
SATooltip.defaultProps = {
    title: undefined,
    icon: undefined,
    theme: SAUX360Theme,
    placement: 'auto',
    variant: 'dark',
    zIndex: 999,
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
//# sourceMappingURL=tooltip.component.js.map